import React from 'react';
import { MenuItem, MenuIcon } from '../../menu-item';
import { ShareLink } from '../../share';
import { isTablet } from '../../../utils/adaptive';
import {
  Nav, Logo, LargeRow, NavWrapper,
} from '../styles/header.style';
import gaEvent from '../../../utils/gaEvent';

/**
 * Header Component
 */
class Header extends React.Component {
  /**
   * Constructor
   * @param {object} props incoming props
   */
  constructor(props) {
    super(props);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.navItemClick = this.navItemClick.bind(this);
    this.state = {
      toggled: false,
      tabletView: false,
    };
  }

  /**
   * Sets tablet state on mount
   */
  componentDidMount() {
    if (isTablet()) {
      this.setState({ tabletView: true });
    }
  }

  /**
   * Send a google analytics event and do a toggle
   * @param {string} destination Link destination
   */
  navItemClick(destination) {
    gaEvent({
      eventCategory: 'Nav',
      eventAction: 'Click',
      eventLabel: destination,
    });
    this.toggleMenu();
  }

  /**
   * Toggles the menu open or closed
   */
  toggleMenu() {
    const { toggled, tabletView } = this.state;
    const newToggle = !toggled;
    if (newToggle && tabletView) {
      window.document.querySelector('html').setAttribute('class', 'locked');
      window.document.querySelector('body').setAttribute('class', 'locked');
    } else {
      window.document.querySelector('html').setAttribute('class', '');
      window.document.querySelector('body').setAttribute('class', '');
    }
    this.setState({
      toggled: newToggle,
    });
  }

  /**
   * Renders the component
   * @returns {XML} A Header
   */
  render() {
    const { toggled, tabletView } = this.state;
    const { teams } = this.props;
    let currentRoute = '';
    let teamsLink = '';
    if (typeof window !== 'undefined' && window.location) {
      currentRoute = window.location.pathname;
    }

    if (teams && teams.edges && teams.edges.length > 0) {
      teamsLink = `/teams/${teams.edges[0].node.urlSlug}`;
    }

    return (
      <NavWrapper>
        <Nav className="nav">
          <Logo className="" data-target="hero" to="/" name="logo" title="XFL Logo" aria-label="Home Page Link">
            <img className="nav__logo" src="/images/XFL_LOGO.svg" alt="XFL Logo" />
          </Logo>
          <div className={`nav__links ${toggled ? 'toggled' : ''}`}>
            <LargeRow className="nav_links-container">
              {tabletView ? (
                <MenuItem exact target="/" text="Home" onClick={() => this.navItemClick('Home')} mobileOnly />
              ) : (
                ''
              )}
              <MenuItem
                target={teamsLink}
                active={currentRoute.indexOf('teams') > -1}
                text="Teams"
                onClick={() => this.navItemClick('Teams')}
              />
              <MenuItem target="/football" text="Football" onClick={() => this.navItemClick('Home')} />
              <MenuItem target="/tickets" text="Tickets" onClick={() => this.navItemClick('Tickets')} />
              <MenuItem target="/watch" text="Watch" onClick={() => this.navItemClick('Watch')} />
              <MenuItem
                target={
                  'https://www.xflshop.com/'
                  + '?utm_source=XFL&utm_medium=Dotcom&utm_term=top&utm_content=link&utm_campaign=nav'
                }
                text="Shop"
                onClick={() => this.navItemClick('Shop')}
              />
              <MenuItem target="/news" text="News" onClick={() => this.navItemClick('News')} />
              <MenuItem target="/faq" text="FAQ" onClick={() => this.navItemClick('FAQ')} />
              <MenuItem
                target="https://www.teamworkonline.com/football-jobs/xfl/xfl-jobs"
                text="Careers"
                onClick={() => this.navItemClick('Careers')}
              />
              <ShareLink desktop />
            </LargeRow>
          </div>
          <MenuIcon onClick={this.toggleMenu} />
        </Nav>
      </NavWrapper>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/components/header.js